import { IApiCommandResponse } from '@llws/api-common';
import config from '@/config';
import { IGenericObject, IApiResponse, IBaseFieldConfig, IMetaResponse, Nullable } from '@/shared';
import { baseRequest } from './base-request';

export const adminRequest = {
  /**
   * @param path - The path to request
   * @param querystring - The querystring to pass to the request. Must be prefixed with '?'!
   */
  get: async <
    TResult extends any = any,
    TMeta extends Nullable<IMetaResponse> = null
  >(
    path: string,
    querystring: string = '',
    exportFields?: IBaseFieldConfig[],
  ): Promise<IApiResponse<TResult, TMeta>> => {
    let result: IApiResponse<TResult, TMeta>;

    if (exportFields) {
      let pathParsed = path;
      pathParsed += pathParsed.includes('?') ? '&csvExport=true' : '?csvExport=true';
      result = await baseRequest.post(`${config?.adminGateway}${pathParsed}`, { fields: exportFields });
    } else {
      result = await baseRequest.get(`${config?.adminGateway}${path}`, querystring);
    }

    return result;
  },

  post: async <
    TResult extends any = any,
    TMeta extends Nullable<IMetaResponse> = null
  >(
    path: string,
    data: IGenericObject,
  ): Promise<IApiResponse<TResult, TMeta>> => baseRequest.post(
    `${config?.adminGateway}${path}`,
    data,
  ),

  put: async <
    TResult extends any = any,
    TMeta extends Nullable<IMetaResponse> = null
  >(
    path: string,
    data: IGenericObject,
  ): Promise<IApiResponse<TResult, TMeta>> => baseRequest.put(
    `${config?.adminGateway}${path}`,
    data,
  ),

  patch: <
    TResult extends any = any,
    TMeta extends Nullable<IMetaResponse> = null
  >(
    path: string,
    data: IGenericObject,
  ): Promise<IApiResponse<TResult, TMeta>> => baseRequest.patch(
    `${config?.adminGateway}${path}`,
    data,
  ),

  delete: <
    TResult extends any = any,
    TIdType extends number | string = number | string
  >(
    path: string,
    ids: TIdType[],
    querystring: string = '',
  ): Promise<IApiCommandResponse<TResult>> => baseRequest.delete<TResult>(
    `${config?.adminGateway}${path}/${ids.join(',')}${(querystring ? `?${querystring}` : '')}`,
  ) as unknown as Promise<IApiCommandResponse<TResult>>,

};
